import { useEffect, useState } from "react";
import { API } from "aws-amplify";
import AgGridComponent from "../../../AG-grid/AgGridComponent";
import LoadableComp from "../../../commonComponents/LoadableComp/LoadableComp";
import "./SistemiIp.scss";
import CreateNewIp from "./CreateNewIp/CreateNewIp";
import Swal from "sweetalert2";
import { useAuth } from "../../../../authentication/authHelpers";
import { v4 as uuidv4 } from "uuid";
import IpLogs from "./IpLogs";
import MondayButton from "../../../commonComponents/MondayButton/MondayButton";
import { useSelector } from "react-redux";

const IP_WHITELIST_FIELD_ID = "4fgtf65fgf-mnjlsdfv-89000nmnbhujj";

const EXPORT_COLS = [
  { en: "ip", al: "IP Adresa" },
  { en: "type", al: "Lloji i IP" },
  { en: "description", al: "Përshkrimi" },
];

function MenaxhimiOrarit() {
  const columnDefs = [
    {
      headerName: "Lloji i IP",
      field: "type",
      filter: "agTextColumnFilter",
      mobile: true,
      cellRenderer: ({ data }) => data.type || "Ip e lejuar",
      flex: 3,
    },
    {
      mobile: true,
      isCollapseTitle: true,
      headerName: "IP Adresa",
      field: "ip",
      filter: "agTextColumnFilter",
      flex: 3,
    },
    {
      mobile: true,
      headerName: "Përshkrimi",
      field: "description",
      filter: "agTextColumnFilter",
      flex: 3,
    },
  ];
  const { isDarkMode } = useSelector((state) => state.usersList);

  const [gridApi, setGridApi] = useState(null);
  // const [selectedRows, setSelectedRows] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [visible, setVisible] = useState(false);
  const [programFields, setProgramFields] = useState({});

  const [logsVisible, setLogsVisible] = useState(false);
  const { userAccess } = useAuth();

  const username = {
    userId: userAccess[0].userSub,
    employeeFirstName: userAccess[0].given_name,
    employeeLastname: userAccess[0].family_name,
  };

  // making ag grid ready
  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  // delete items from grid
  const deleteItems = async () => {
    const selectedData = (gridApi.getSelectedNodes() || []).map(
      (node) => node.data.ip
    );
    const newWhiteList = tableData
      .filter((item) => !selectedData.includes(item.ip))
      .map((el) => (isObj(el) ? el : { ip: el }));
    const logs = [...(programFields.fieldOptions?.logs || [])];
    if (!!selectedData.length) {
      selectedData.forEach((item) => {
        logs.push({
          id: uuidv4(),
          activity: "U Hoq",
          author: username,
          changeDate: Date.now(),
          currentData: item,
        });
      });
    }
    await API.put("programFields", `/programFields/${IP_WHITELIST_FIELD_ID}`, {
      body: { fieldOptions: { whiteList: newWhiteList, logs } },
    }).then(() => {
      setTableData(newWhiteList);
      setProgramFields((prev = {}) => ({
        ...prev,
        fieldOptions: { whiteList: newWhiteList, logs },
      }));
      Swal.fire({
        title: "Sukses",
        text: "Ip Adresa u fshi me sukses",
        customClass: {
          popup: isDarkMode ? "custom-swal-dark" : "custom-swal",
        },
        icon: "success",
      });
    });
    // API.del("shifts", `/shifts/${selectedData}`).then((r) => setTableData(r));
  };

  const getIps = async () => {
    await API.get(
      "programFields",
      `/programFields/${IP_WHITELIST_FIELD_ID}`
    ).then((res) => {
      let whiteLists = res?.fieldOptions?.whiteList || [];
      // let blackLists = res?.fieldOptions?.blackList || [];
      setProgramFields(res);
      if (whiteLists.length > 0)
        setTableData(
          whiteLists.map((item) => (isObj(item) ? item : { ip: item }))
        );
    });
  };

  useEffect(() => {
    getIps();
  }, []);

  const ITEMS = {
    search: {},
    icons: {
      excel: { tableCols: EXPORT_COLS },
      pdf: { tableCols: EXPORT_COLS },
      print: { tableCols: EXPORT_COLS },
      delete: { onClick: deleteItems },
      modals: [{ onClick: () => setLogsVisible(true) }],
    },
  };

  return (
    <LoadableComp loading={false}>
      <div className="globalPageWrapper">
        <AgGridComponent
          gridApi={gridApi}
          rowData={tableData}
          rowSelection={{ mode: "singleRow" }}
          onGridReady={onGridReady}
          paginationPageSize={9}
          columnDefs={columnDefs}
          suppressServerSideInfiniteScroll={"full"}
          enableCellChangeFlash={true}
          rowModelType={"serverSide"}
          headerProps={{
            items: ITEMS,
            exportTitle: "Sistemi IP",
            children: [
              <MondayButton
                className="mondayButtonGreen"
                onClick={() => {
                  setVisible(true);
                }}
              >
                Krijo nje IP te re
              </MondayButton>,
            ],
          }}
          idKey={"ip"}
        />
      </div>
      {visible ? (
        <CreateNewIp
          {...{
            tableData,
            gridApi,
            setTableData,
            programFields,
            setProgramFields,
            visible,
            setVisible,
            username,
          }}
        />
      ) : null}
      {logsVisible ? (
        <IpLogs
          isVisible={logsVisible}
          setIsVisible={setLogsVisible}
          data={programFields}
        />
      ) : null}
    </LoadableComp>
  );
}

export default MenaxhimiOrarit;

const isObj = (e) => typeof e === "object" && e !== null && !Array.isArray(e);
